import { useEffect } from 'react'

import { useSessionContext } from 'hooks/SessionContext'
import { useStoreContext } from 'hooks/StoreContext'

import Api from 'services/api'

const useUnassignedDevices = (refresh?: number) => {
  const { session: { impersonateDealerId, dealerId } } = useSessionContext()
  const resolvedDealerId = impersonateDealerId || dealerId

  const {
    unassignedDevices,
    setUnassignedDevices,
    areUnassignedDevicesLoaded,
    setAreUnassignedDevicesLoaded
  } = useStoreContext()

  useEffect(() => {
    Api.UnassignedDevices.list(resolvedDealerId)
      .then((res) => {
        setUnassignedDevices(res)
        setAreUnassignedDevicesLoaded(true)
      })
      .catch(() => {
        setUnassignedDevices(null)
        setAreUnassignedDevicesLoaded(true)
      })
  }, [resolvedDealerId, refresh]) // eslint-disable-line react-hooks/exhaustive-deps

  return { unassignedDevices, areUnassignedDevicesLoaded }
}

export default useUnassignedDevices
